
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/mobile/prepay",
      function () {
        return require("private-next-pages/shop/mobile/prepay/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/mobile/prepay"])
      });
    }
  